import React, { ReactNode }                         from "react";
import { connect }                                  from "react-redux";
import MenuType                                     from "../../../domain/menu/MenuType";
import { ResKaState }                               from "../../../index";
import Breadcrumbs                                  from "../../components/common/Breadcrunmbs";
import TopSection                                   from "../../components/common/layout/TopSection";
import CustomerEditTab                              from "../../components/customer/CustomerEditTab";
import ResKaBaseContainer, { BaseProps, BaseState } from "../ResKaBaseContainer";

class CustomerEditContainer extends ResKaBaseContainer<BaseProps, BaseState> {
  constructor(props: BaseProps) {
    const state = {
      headerTitle: "顧客編集",
      menuType: MenuType.CUSTOMER,
    };

    super(props, state);
  }

  protected componentDidMountInternal(): void {
  }

  protected renderInternal(): ReactNode {
    return (
      <>
        <TopSection>
          <Breadcrumbs breadcrumbs={
            [
              {
                title: "顧客一覧",
                path: "/customers"
              },
              {
                title: "基本情報",
                path: "/customer/edit"
              },
            ]
          }/>
        </TopSection>

        <CustomerEditTab/>
      </>
    );
  }

}

const mapStateToProps = (state: ResKaState) => ({
  fetchStatus: state.fetchStatus,
});

export default connect(mapStateToProps)(CustomerEditContainer);
